import React from "react";
import injectSheet from "react-jss";
import { DragSource } from "react-dnd";
import clsx from "clsx";

const FloorplanImages = ({ classes, images, height, used }) => (
  <div className={classes.container}>
    {images
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      .map(item => (
        <FloorplanImage
          key={item.id}
          image={item}
          classes={classes}
          disabled={used.includes(item.id)}
        />
      ))}
  </div>
);

const imageSource = {
  beginDrag(props) {
    return {
      id: props.image.id,
    };
  },
};

const FloorplanImage = DragSource(
  "floorplan-image",
  imageSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
  }),
)(({ classes, image, connectDragSource, disabled }) => {
  return connectDragSource(
    <div className={clsx(classes.image, { [classes.disabled]: disabled })}>
      {image.name && image.name.length > 0 && (
        <div className={classes.name}>{image.name}</div>
      )}
      <img src={image.urls.low} alt="" style={{ pointerEvents: "none" }} />
    </div>,
  );
});

const styles = theme => ({
  container: {
    display: "flex",
    "flex-wrap": "wrap",
    flex: 1,
    padding: [5, 15, 30],
    "overflow-x": "hidden",
    "overflow-y": "auto",
    "align-items": "flex-start",
  },
  image: {
    flex: 1,
    "max-width": "200px",
    "min-width": "200px",
    "transition-duration": theme.transitionDuration,
    "transition-property": "transform, opacity",
    cursor: "move",
    border: `1px solid ${theme.colorGrey}`,
    "border-radius": theme.borderRadius,
    margin: theme.spacing2,
    "background-color": theme.colorBackground,
    padding: theme.spacing2,
    "box-sizing": "border-box",
    "line-height": 0,

    "& img": {
      "border-radius": theme.borderRadius,
      width: "100%",
      height: 90,
      "object-fit": "cover",
      "object-position": "top",
    },

    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  name: {
    "text-align": "left",
    color: theme.textColor,
    "padding-bottom": theme.spacing2,
    "line-height": "1rem",
  },
  disabled: {
    opacity: 0.5,

    "&:hover": {
      transform: "scale(1.02)",
    },
  },
});

export default injectSheet(styles)(FloorplanImages);
